import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

//Iconos
import { IoMdAdd } from "react-icons/io"

import Swal from 'sweetalert2';
import { useContext, useEffect, useState } from "react";
import { usuariosBuscar, usuarioDelete, usuarioMostrar, grupoMostrarGruposPorUsuario, usuarioObtenerCompaniasYSucursales, usuarioReiniciarContraseña } from "../api/usuarios.api";
import { DataContext } from "../../../app/providers/DataContext";
import { obtenerLocalStorage } from "../../../shared/utils/funciones";
import { sedesPorCompania } from "../../sedes";
import { useMobileDetection } from "../../../shared/hooks/useMobileDetection";
import { CONST_KEY_USUARIO_AUTENTICADO, CONST_ROL_MASTER } from "../../../app/constants/constanst-valores";
import { validarAutenticacion } from "../../auth";
import { CONST_CODIGO_USUARIOS_AGREGAR, CONST_CODIGO_USUARIOS_EDITAR, CONST_CODIGO_USUARIOS_ELIMINAR, CONST_CODIGO_USUARIOS_GRUPOS, CONST_CODIGO_USUARIOS_RESETEAR_CONTRASEÑA, CONST_RUTA_SIN_ACCESO, CONST_RUTA_USUARIOS_AGREGAR, CONST_RUTA_USUARIOS_EDITAR, CONST_RUTA_USUARIOS_GRUPOS, CONST_RUTA_USUARIOS_LISTAR } from "../../../app/constants/constants-rutas-codigos";
import { sucursalesPorCompania } from "../../sucursales";
import { useRefetchAlCerrarModal } from "../../../shared/hooks/useRefetchAlCerrarModal";
// DT1 (refactor por tamaño): filtros y tabla extraídos a subcomponentes presentacionales.
import { UsuariosFiltros } from "../components/UsuariosFiltros";
import { UsuariosTabla } from "../components/UsuariosTabla";
import { useQuery, useQueryClient } from "@tanstack/react-query";

// ítem 15 (React Query, fase 2): referencia ESTABLE para el listado vacío. El useEffect que congela
// `sucursalesTabla` está keyed por [listaUsuarios]; si `listaUsuarios` fuese un `?? []` nuevo en cada
// render (mientras la query aún no trae datos), el efecto dispararía de más. Con una ref estable, solo
// dispara cuando cambian los RESULTADOS reales — que es justo lo que protege la columna "Sucursal".
const EMPTY_USUARIOS: any[] = [];

export const Usuarios = () => {

  const { listaRutasDeAcceso } = useContext(DataContext);

  const [listaCompanias, setListaCompanias] = useState<any[]>([])
  const [listaSucursales, setListaSucursales] = useState<any[]>([])
  const [listaSedes, setListaSedes] = useState<any[]>([])
  // Carga de los filtros/selects (compañía, sucursal, sede) al montar. Empieza en true
  // para mostrar "Cargando…" en los selects y que NO parezca que la data falla mientras llega.
  const [isLoadingFiltros, setIsLoadingFiltros] = useState(true)

  const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO);

  // console.log('usuarioAutenticado',usuarioAutenticado)
  const rol = usuarioAutenticado?.tipo

  //Estados para ver si mostrar o no los botones
  const [mostrarBotonAgregar, setMostrarBotonAgregar] = useState(false)
  const [mostrarBotonEditar, setMostrarBotonEditar] = useState(false)
  const [mostrarBotonEliminar, setMostrarBotonEliminar] = useState(false)
  const [mostrarBotonUsuarioGrupo, setMostrarBotonUsuarioGrupo] = useState(false)
  const [mostrarBotonUsuarioResetearContraseña, setMostrarBotonUsuarioResetearContraseña] = useState(false)


  //Obtener datos para la busqueda rapida
  const location = useLocation();
  const datosParaBusquedaRapida = location?.state || null

  //console.log("los datos de busqueda son: ", datosParaBusquedaRapida)

  const isMobile = useMobileDetection()

  const { register, handleSubmit, watch, setValue } = useForm<any>({
    defaultValues: {
      NombreCompleto: "",
      Estado: "A",
    }
  });


  // ítem 15 (React Query, fase 2): SOLO el listado de usuarios pasa a useQuery; toda la maquinaria
  // de selects (compañía/sucursal/sede), la cascada onChange, la siembra por location.state y el
  // snapshot de abajo quedan INTACTOS.
  const queryClient = useQueryClient()
  const [filtrosAplicados, setFiltrosAplicados] = useState<any>(null)

  const { data: usuariosData, isFetching } = useQuery({
    queryKey: ["seg-usuarios", filtrosAplicados],
    queryFn: () => usuariosBuscar({ ...filtrosAplicados, token: usuarioAutenticado?.token }),
    enabled: filtrosAplicados !== null,
  })

  // Derivados (equivalentes 1:1 a listaUsuarios/isLoading/buscar). EMPTY_USUARIOS estable para el snapshot.
  const listaUsuarios: any[] = usuariosData?.usuarios ?? EMPTY_USUARIOS
  const isLoading = isFetching
  const buscar = filtrosAplicados !== null

  // Snapshot de las sucursales con las que se ETIQUETA la tabla. Se congela al momento de la
  // busqueda: cambiar el filtro de Compania (que re-carga listaSucursales para el SELECT) ya
  // NO deja en blanco la columna "Sucursal" de los resultados actuales; solo cambia al buscar.
  const [sucursalesTabla, setSucursalesTabla] = useState<any[]>([])

  const [, setMostrarOpcionTodos] = useState(true)

  const onSubmitBuscar = (data) => {
    // Aplica los filtros del formulario; useQuery re-consulta. invalidate = paridad con el flujo
    // previo (siempre re-consultaba al pulsar buscar, aunque no cambien los filtros).
    setFiltrosAplicados({
      Compania: data?.compania,
      Estado: data?.Estado,
      NombreCompleto: data?.NombreCompleto,
      Sede: data?.Sede || "T",
      Sucursal: data?.sucursal,
    })
    queryClient.invalidateQueries({ queryKey: ["seg-usuarios"] })
  };
  const resetPassword = async (UseCod) => {
    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, CONST_CODIGO_USUARIOS_RESETEAR_CONTRASEÑA)
    if (!validarAutenticado) {
      navigate(CONST_RUTA_SIN_ACCESO)
      return
    }

    // QA "Restablecer contraseña" 2026-08-14: el backend ya NO fija la contraseña = usuario.
    // Genera una contraseña COMPLEJA aleatoria y la ENVÍA por correo al usuario (nunca vuelve
    // al navegador). La confirmación refleja ese comportamiento.
    const confirmar = await Swal.fire({
      title: '¿Reiniciar contraseña?',
      html: `Se reiniciará la contraseña de <b>${UseCod}</b>.<br/>Se generará una contraseña segura y se enviará al <b>correo registrado</b> del usuario.`,
      icon: 'warning' as const,
      showCancelButton: true,
      confirmButtonColor: '#6366f1',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Reiniciar',
      cancelButtonText: 'Cancelar',
    })
    if (!confirmar.isConfirmed) return

    // El backend (c_usuario.reiniciar_contrasena) genera la clave compleja, la envía por
    // correo y SOLO la persiste si el correo llegó (status 1). Si el canal no está
    // configurado, no hay correo o el envío falla, responde status 0 con el motivo.
    const dataPOST = {
      usuario: UseCod,
      token: usuarioAutenticado?.token
    }
    const res = await usuarioReiniciarContraseña(dataPOST)

    if (res?.status === 1) {
      // La contraseña NO se muestra (viaja por correo, no al navegador). Se muestra el
      // mensaje del backend ("Se envió la nueva contraseña al correo del usuario.").
      Swal.fire({
        title: 'Contraseña reiniciada',
        html: res?.message || `Se envió la nueva contraseña al correo de <b>${UseCod}</b>.`,
        icon: 'success' as const,
      })
    } else {
      // status 0: el backend indica el motivo (canal no configurado / sin correo / envío
      // falló). La contraseña actual del usuario NO se modificó.
      Swal.fire('No se pudo reiniciar la contraseña', res?.message || '', 'warning')
    }
  }


  const navigate = useNavigate()

  const usuarioAgregar = async () => {

    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, CONST_CODIGO_USUARIOS_AGREGAR)
    if (validarAutenticado) {
      navigate(CONST_RUTA_USUARIOS_AGREGAR,{state:{compania:watch("compania"),sucursal1:watch("sucursal"),sede1:watch("Sede")}} )
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }
  }

  const usuarioGrupo = async (compania, nombreUsuario, codUsuario) => {

    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, CONST_CODIGO_USUARIOS_GRUPOS)

    if (validarAutenticado) {
      const dataPOST = {
        codigo_usuario: codUsuario,
        compania: compania,
        token: usuarioAutenticado?.token
      }

      const { grupos } = await grupoMostrarGruposPorUsuario(dataPOST)

      navigate(CONST_RUTA_USUARIOS_GRUPOS, {
        state: {
          grupos: grupos,
          nombreUsuario: nombreUsuario,
          codUsuario: codUsuario,
          compania: compania
        }
      })
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }

  }

  const usuarioEditar = async (UseCod) => {

    const validarAutenticado = await validarAutenticacion(usuarioAutenticado?.token, CONST_CODIGO_USUARIOS_EDITAR)

    if (validarAutenticado) {

      const dataPOST = {
        usuario: UseCod,
        token: usuarioAutenticado?.token
      }
      const { usuario } = await usuarioMostrar(dataPOST)

      navigate(CONST_RUTA_USUARIOS_EDITAR, {
        state: {usuario:usuario, compania:watch("compania"),sucursal1:watch("sucursal"),sede1:watch("Sede")}
      })
    } else {
      navigate(CONST_RUTA_SIN_ACCESO)
    }
  }

  const optionsEliminar = (nombreCompleto) => {
    return {
      title: `¿Estás seguro de eliminar al usuario: ${nombreCompleto}?`,
      icon: 'warning' as const,
      showCancelButton: true,
      cancelButtonColor: '#6c757d',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }
  }

  const usuarioEliminar = (usuario, nombreCompleto) => {
    Swal.fire(optionsEliminar(nombreCompleto)).then(async (result) => {
      if (result.isConfirmed) {

        const dataPOST = {
          usuario: usuario,
          token: usuarioAutenticado?.token
        }

        const { status, message } = await usuarioDelete(dataPOST)
        if (status === 1) {
          obtenerUsuarios()
          Swal.fire(
            'Usuario eliminado',
            '',
            'success'
          )
        } else {
          // REF-ERRORES-ESPECIFICOS (2026-07-14): icono corregido ('success'→
          // 'error') + se muestra el motivo del backend.
          Swal.fire(
            'Error al eliminar usuario',
            message || '',
            'error'
          )
        }
      }
    })
  }

  // Aplica los filtros actuales (watch) y fuerza re-fetch fresco. Lo usan la carga inicial,
  // el post-eliminar y el cierre de modal (invalidate = re-consulta aunque la clave no cambie).
  const obtenerUsuarios = () => {
    setFiltrosAplicados({
      // UseCod: watch("UseCod") || "",
      NombreCompleto: "",
      Compania: watch("compania"),
      Sucursal: watch("sucursal"),
      Estado: watch("Estado") || "A",
      Sede: watch("Sede"),
    })
    queryClient.invalidateQueries({ queryKey: ["seg-usuarios"] })
  }



  const obtenerCompaniasYSucursales = async () => {

    const dataPOST = {
      token: usuarioAutenticado?.token
    }

    const { companias, sucursales, sedes } = await usuarioObtenerCompaniasYSucursales(dataPOST)

    setListaCompanias(companias)
    setListaSucursales(sucursales)
    setValue("compania", datosParaBusquedaRapida == null ? companias?.[0]?.id : datosParaBusquedaRapida?.codCompania)

    return {
      companias: companias,
      sucursales: sucursales,
      sedes:sedes
    }
  }

  const obtenerSucursalesPorCompaniaPorDefecto = async (idCompania) => {

    const dataPOST = {
      token: usuarioAutenticado?.token,
      Codigo: idCompania,
      Estado: "A"
    }

    const { sucursales } = await sucursalesPorCompania(dataPOST)

    const listaSucursalesFormateada = sucursales?.map(s => ({
      id: s?.CompCod,
      tipo: s?.CompNom
    }))

    setListaSucursales(listaSucursalesFormateada)
    setValue("sucursal", datosParaBusquedaRapida == null ? sucursales?.[0]?.CompCod : datosParaBusquedaRapida?.codSucursal)

  }

  const obtenerSedesPorSucursalPorDefecto = async (idSucursal) => {

    const dataPOST = {
      compania: idSucursal,
      token: usuarioAutenticado?.token
    }

    const { sedes } = await sedesPorCompania(dataPOST)
    setListaSedes(sedes)
    setValue("Sede", datosParaBusquedaRapida == null ? ("T") : (datosParaBusquedaRapida?.codSede))
    //setValue("Sede", datosParaBusquedaRapida == null ? ("T") : datosParaBusquedaRapida?.codSede)

  }

  const obtenerSucursalesPorCompania = async (idCompania) => {

    const dataPOST = {
      token: usuarioAutenticado?.token,
      Codigo: idCompania,
      Estado: "A"
    }
    const { sucursales } = await sucursalesPorCompania(dataPOST)

    const listaSucursalesFormateada = sucursales?.map(s => ({
      id: s?.CompCod,
      tipo: s?.CompNom
    }))
    setListaSucursales(listaSucursalesFormateada)
    setValue("compania", idCompania)
    setValue("sucursal", sucursales?.[0]?.CompCod)

  }

  const obtenerSedesPorSucursal = async (idCompania) => {

    const dataPOST = {
      compania: idCompania,
      token: usuarioAutenticado?.token
    }

    const { sedes } = await sedesPorCompania(dataPOST)

    setListaSedes(sedes)
    setValue("sucursal", idCompania)
    // datosParaBusquedaRapida ya tiene datosParaBusquedaRapida?.codSede
    //setValue("Sede", sedes?.[0]?.SedCod)
    setValue("Sede", "T")

  }

  useEffect(() => {

    const encontradoRutaBotonAgregar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_AGREGAR)
    const encontradoRutaBotonEditar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_EDITAR)
    const encontradoRutaBotonEliminar = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_ELIMINAR)
    const encontradoRutaBotonUsuarioGrupo = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_GRUPOS)
    const encontradoRutaBotonUsuarioResetearContraseña = listaRutasDeAcceso?.find(r => r.codigo_programa === CONST_CODIGO_USUARIOS_RESETEAR_CONTRASEÑA)

    encontradoRutaBotonAgregar ? setMostrarBotonAgregar(true) : setMostrarBotonAgregar(false)
    encontradoRutaBotonEditar ? setMostrarBotonEditar(true) : setMostrarBotonEditar(false)
    encontradoRutaBotonEliminar ? setMostrarBotonEliminar(true) : setMostrarBotonEliminar(false)
    encontradoRutaBotonUsuarioGrupo ? setMostrarBotonUsuarioGrupo(true) : setMostrarBotonUsuarioGrupo(false)
    // La operación "Reiniciar contraseña" es MASTER-ONLY en el backend: el endpoint
    // ReiniciarContrasenia exige caller con nivel 'M' (bloqueaSiCallerNoMaster → 403 si no).
    // Por eso la llave debe verse SIEMPRE para un usuario master, aunque su grupo NO tenga
    // asignado el programa S0101050000 (RutaPlana). Se mantiene además el permiso por grupo.
    ;(rol === CONST_ROL_MASTER || encontradoRutaBotonUsuarioResetearContraseña)
      ? setMostrarBotonUsuarioResetearContraseña(true)
      : setMostrarBotonUsuarioResetearContraseña(false)

  }, [listaRutasDeAcceso, rol])
  /* useEffect(() => {
    resetPassword()
  },[]) */

  useEffect(() => {

    const cargarDatosIniciales = async () => {
      try {
        const { sucursales, sedes } = await obtenerCompaniasYSucursales()
        if (rol === CONST_ROL_MASTER) {
          await obtenerSucursalesPorCompaniaPorDefecto(watch("compania"));

        } else {
          setListaSucursales(sucursales)
          //setValue("sucursal", sucursales?.[0]?.id) //datosParaBusquedaRapida == null ? sucursales?.[0]?.CompCod : datosParaBusquedaRapida?.codSucursal
          setValue("sucursal", datosParaBusquedaRapida == null ? sucursales?.[0]?.id : datosParaBusquedaRapida?.codSucursal) //datosParaBusquedaRapida == null ? sucursales?.[0]?.CompCod : datosParaBusquedaRapida?.codSucursal
        }
        if (sucursales?.length > 1) {
          //console.log("entro al if")
          await obtenerSedesPorSucursalPorDefecto(watch("sucursal"));

        } else {
          //console.log("entro al else")
          const listaSedesFormateada = sedes?.map(s => ({
            SedCod: s?.id,
            SedDesc: s?.tipo
          }))
          setListaSedes(listaSedesFormateada)
          //setValue("Sede", datosParaBusquedaRapida == null ? (listaSedesFormateada?.[0]?.SedCod || "T") : datosParaBusquedaRapida?.codSede)
          setValue("Sede", "T")
          setMostrarOpcionTodos(false)
        }

        obtenerUsuarios()
      } finally {
        // Los selects ya tienen data (o falló): apagamos el indicador de carga de filtros.
        // (obtenerUsuarios ahora sólo fija filtros; la lista carga vía useQuery con su propio isLoading.)
        setIsLoadingFiltros(false)
      }
    };

    cargarDatosIniciales();
    // carga inicial (una sola vez al montar)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // El listado queda montado de fondo cuando se abre el modal (agregar/editar/grupos);
  // al cerrarlo (regreso a la ruta base) se refresca conservando los filtros actuales.
  useRefetchAlCerrarModal(CONST_RUTA_USUARIOS_LISTAR, obtenerUsuarios)

  // Congela las sucursales para etiquetar la tabla SOLO cuando cambian los RESULTADOS
  // (busqueda/carga), no cuando cambia el filtro. Asi la columna "Sucursal" no se vacia al
  // cambiar de Compania sin buscar. Depende de listaUsuarios a proposito.
  useEffect(() => {
    setSucursalesTabla(listaSucursales)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listaUsuarios])

  return (
    <>
      <div className="p-3">
        <div className="container-fluid" >
          <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Usuarios</h3>

          {/* Formulario */}
          <div className="tw-mb-4 tw-rounded-2xl tw-bg-white tw-p-4 tw-shadow-md tw-border tw-border-gray-100">
            <form onSubmit={handleSubmit(onSubmitBuscar)} className="row g-2">

              <UsuariosFiltros
                register={register}
                watch={watch}
                listaCompanias={listaCompanias}
                listaSucursales={listaSucursales}
                listaSedes={listaSedes}
                obtenerSucursalesPorCompania={obtenerSucursalesPorCompania}
                obtenerSedesPorSucursal={obtenerSedesPorSucursal}
                handleSubmit={handleSubmit}
                onSubmitBuscar={onSubmitBuscar}
                isMobile={isMobile}
                isLoadingFiltros={isLoadingFiltros}
              />
            </form>
          </div >
          {/* Fin formulario */}

          {
            mostrarBotonAgregar && (
              <div className="tw-mb-3">
                <button className='btn btn-primario btn-sm tw-inline-flex tw-items-center tw-gap-1 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow' onClick={usuarioAgregar}>
                  <IoMdAdd size={18} />
                  <span>Agregar</span>
                </button>
              </div>
            )
          }


          {/* Tabla de resultados */}

          <UsuariosTabla
            isLoading={isLoading}
            listaUsuarios={listaUsuarios}
            listaSucursales={sucursalesTabla}
            buscar={buscar}
            watch={watch}
            mostrarBotonUsuarioGrupo={mostrarBotonUsuarioGrupo}
            mostrarBotonUsuarioResetearContraseña={mostrarBotonUsuarioResetearContraseña}
            mostrarBotonEditar={mostrarBotonEditar}
            mostrarBotonEliminar={mostrarBotonEliminar}
            usuarioGrupo={usuarioGrupo}
            resetPassword={resetPassword}
            usuarioEditar={usuarioEditar}
            usuarioEliminar={usuarioEliminar}
          />


          {/* Fin Tabla de resultados */}
        </div>

      </div>

    </>
  )
};

